
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Loading } from "../../../../componentes/loading/loading";

function RankingDepartamentos({ data, filtrar, loading, alterarDepartamento }) {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [tamanho, setTamanho] = useState(0);

  useEffect(() => {
    if (data?.topDepartamentos && Object.keys(data.topDepartamentos).length > 0) {
      const labels = Object.keys(data.topDepartamentos);
      const values = Object.values(data.topDepartamentos);
      setTamanho(values.length);

      setChartOptions({
        chart: {
          type: "bar",
          toolbar: { show: true },
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const index = config.dataPointIndex;
              const label = labels[index];
              alterarDepartamento(label);
            }
          }
        },
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 4,
            horizontal: false,
            columnWidth: "50%"
          }
        },
        dataLabels: { enabled: false },
        xaxis: { categories: labels },
        colors: [
          "#515b68ff",
          "#F97316",
          "#14B8A6",
          "#3B82F6",
          "#f4f801ff",
          "#f016a7ff",
          "#c5c222ff"
        ],
        legend: { show: false }
      });

      setChartSeries([{ name: "Valor Gasto", data: values }]);
    } else {
      setChartSeries([]);
    }
  }, [data, filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 lg:col-span-1 lg:min-h-[423px]">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Top 5 Departamentos
      </h3>
      <label className="text-muted-foreground text-sm">
        Ranking dos departamentos com maiores valores de despesa.
      </label>
 
        {!loading ? (
          tamanho > 0 ? (
            <Chart
              options={chartOptions}
              series={chartSeries}
              type="bar"
              height={280}
            />
          ) : (
            "Não existem dados disponíveis para o intervalo selecionado."
          )
        ) : (
          <Loading />
        )}
     
    </div>
  );
}

export default RankingDepartamentos;
